module.exports = __webpack_public_path__ + "static/media/P16.e5840889.jpg";